import axios from "axios"
import {Message,Loading} from "element-ui"

// import store from '../store/index'

import router from "../router/index"
let loading ;
// import config from "../config/index"
let instance = axios.create({
    timeout: 10*60000,
    headers: {'content-type': 'application/json'}
});

// // 添加请求拦截器
instance.interceptors.request.use(function (config) {
    loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
    });
    const token = localStorage.getItem('token')
    config.headers['token'] = token
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
    return config;
}, function (error) {
    if (loading){
        loading.close();
    }
    return Promise.reject(error);
});




// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // console.log(response)
    if (response.data.code===10086){
        if (loading){
            loading.close();
        }
        localStorage.removeItem('token')
        router.push({name:'index'})
        return
    }

    if (loading){
        loading.close();
    }

    // 默认模块文档示例为 code:0；若后端实际返回 0，需与登录等处一并放开判断
    if (response.data.code===200){
        return response
    }else if(response.data.code===414){
        return response
    } else {
        Message.error(response.data.msg)
    }

    // return response
}, function (error) {
    if (loading){
        loading.close();
    }

    if (error.search('Timeout') === -1) {
        Message.error('系统错误')
    } else {
        Message.error('请求连接超时')
    }
    // return Promise.reject(error);
});

export default instance
